/* eslint-disable */
import KeenSlider from 'keen-slider';
import gsap from 'gsap';

export default function initTeamGridCarousel() {

    const sections = document.querySelectorAll('.team-grid-section, .tabbed-calculator-section, .tabbed-faq-section');

    sections.forEach(section => {

        const carouselElement = section.querySelector('.team-grid-slider');
        const prevBtn = section.querySelector('.tabbed-nav-buttons .slider-nav-prev');
        const nextBtn = section.querySelector('.tabbed-nav-buttons .slider-nav-next');
        const indicators = section.querySelectorAll('.tabbed-nav-tabs li');

        let hasInited = false;
        let parentCarousel;
        let parentSlides;
        let currentSlide;
        let slideHeightObserver;

        const AccesibilityPlugin = (slider) => {

            const slides = slider.slides;

            const onMove = (e) => {
                const slidesData = slider.track.details.slides;
                for (let i = 0; i < slides.length; i++) {
                    slides[i].setAttribute('aria-hidden', false);
                }
            };

            const onRest = (e) => {
                const slidesData = slider.track.details.slides;

                for (let i = 0; i < slides.length; i++) {
                    const slideData = slidesData[i];
                    slides[i].setAttribute('aria-hidden', (slideData.portion === 0));
                }
            }

            slider.on('created', () => { setTimeout(onRest, 200) });
            slider.on('slideChanged', onRest);
            slider.on('dragStart', onMove);
            slider.on('animationStarted', onMove);
            slider.on('animationEnded', onRest);
            // slider.on('updated', {} );

        };

        const WheelControlsPlugin = (slider) => {

            let touchTimeout, position, wheelActive;

            const dispatch = (e, name) => {
                position.x -= e.deltaX;
                position.y -= e.deltaY;
                slider.container.dispatchEvent(new CustomEvent(name, { detail: { x: position.x, y: position.y } }));
            };

            const wheelStart = (e) => {
                position = { x: e.pageX, y: e.pageY };
                dispatch(e, "ksDragStart");
            };

            const wheel = (e) => dispatch(e, "ksDrag");
            const wheelEnd = (e) => dispatch(e, "ksDragEnd");

            const eventWheel = (e) => {
                if (e.deltaX === 0) return false;

                e.preventDefault();
                if (!wheelActive) {
                    wheelStart(e);
                    wheelActive = true;
                }
                wheel(e);
                clearTimeout(touchTimeout);
                touchTimeout = setTimeout(() => {
                    wheelActive = false;
                    wheelEnd(e);
                }, 50);
            };

            slider.on("created", () => {
                slider.container.addEventListener("wheel", eventWheel, { passive: false });
            });
        };

        const init = () => {

            if( section.classList.contains('team-grid-section') ) {
                if (document.visibilityState !== 'visible') {
                    document.addEventListener('visibilitychange', function () {
                        if (document.visibilityState === 'visible' && !hasInited) {
                            setTimeout( initTeamGrid , 100 );
                        }
                    });
                } else {
                    initTeamGrid();
                }
            }

            if( !carouselElement ) return;

            // get bottom padding of carouselElement
            carouselElement.style.visibility = 'hidden';
            parentSlides = carouselElement.querySelectorAll('.team-slide');

            const onSlideChanged = (s) => {
                const curSlide = parentSlides[s.track.details.rel];
                const curSlideTopBotPadding = parseInt(window.getComputedStyle(curSlide).paddingTop) + parseInt(window.getComputedStyle(curSlide).paddingBottom);
                const curSlideContent = curSlide.querySelector('.slide-inner');
                const h = curSlideContent.offsetHeight;
                carouselElement.style.height = h + curSlideTopBotPadding + 'px';

                currentSlide = curSlide;

                if (slideHeightObserver) slideHeightObserver.disconnect();
                slideHeightObserver = new ResizeObserver(entries => {
                    for (let entry of entries) {
                        const h = entry.target.offsetHeight;
                        carouselElement.style.height = h + curSlideTopBotPadding + 'px';
                    }
                });
                slideHeightObserver.observe(curSlideContent);

                indicators.forEach( (indicator) => {
                    if ( indicator.classList.contains('active') ) {
						//TODO this is close but doesn't cover all cases
                        const indicatorParent = indicator.parentElement;
                        const indicatorRect = indicator.getBoundingClientRect();
						const indicatorParentRect = indicatorParent.getBoundingClientRect();
                        let offsetLeft = indicatorRect.left - indicatorParentRect.left;
                        if(offsetLeft >= indicatorParentRect.width) {
							offsetLeft += indicatorRect.width;
						}
						indicatorParent.scrollLeft = offsetLeft + (indicatorParent.scrollWidth - indicatorParent.clientWidth) / 2 - indicatorParent.clientWidth / 2;
                    }
                });
            };


            parentCarousel = new KeenSlider( carouselElement, {
                selector: parentSlides,
                slides: { perView: 1, spacing: 100, origin: 'auto' },
                loop: true,
                drag: false,
                defaultAnimation: {
                    duration: 0,
                },
                breakpoints: {
                    '(min-width: 576px)': {
                        drag: true,
                        slides: { perView: 1, spacing: 1000, origin: 'auto' },
                        defaultAnimation: {
                            duration: 1000,
                        },
                    },
                },
                slideChanged: (s) => {
                    onSlideChanged(s);
                },
                created: (s) => {
                    // give time for the slide to render
                    setTimeout( ()=>{ onSlideChanged(s) } , 100 );
                },
                detailsChanged: (s) => {
                    /*s.slides.forEach((element, idx) => {
                        element.style.opacity = s.track.details.slides[idx].portion
                    })*/
                    indicators.forEach((indicator, i) => {
                        if (i === s.track.details.rel) {
                            indicator.classList.add('active');
							indicator.setAttribute('aria-selected', true);
                        } else {
                            indicator.classList.remove('active');
							indicator.setAttribute('aria-selected', false);
                        }
                    });
                },
                renderMode: "precision",
            });

            if( prevBtn && nextBtn && indicators ) {

                prevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    parentCarousel.prev();
                });

                nextBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    parentCarousel.next();
                });

                if (indicators && indicators.length) {
                    indicators.forEach( (indicator, i) => {
                        indicator.addEventListener('click', (e) => {
                            console.log('click', i);
                            e.preventDefault();
                            parentCarousel.moveToIdx(i);
                        });
                    });
                }
            }


            //window.addEventListener('resize', handleResize);
            //handleResize();

            setTimeout(() => {
                carouselElement.style.visibility = 'visible';
            }, 200);
        };

        const handleResize = (e) => {

            /*const carouselWidth = carouselElement.offsetWidth;
            console.log( carouselWidth );

            parentSlides.forEach(slide => {
                slide.style.width = carouselWidth + 'px';
            });*/

            /*let newHeight = 0;
            parentSlides.forEach(slide => {
                slide.style.height = 'auto';
                if (slide.offsetHeight > newHeight) {
                    newHeight = slide.offsetHeight;
                }
            });
            carouselElement.style.height = newHeight + 'px';*/
        };

        /**
         * init team grid
         * normalize height of team grid items
         */
        const initTeamGrid = () => {
            console.log('initTeamGrid');
            
            hasInited = true;

            section.querySelectorAll('.team-slide').forEach(slide => {
                const cards = slide.querySelectorAll('.card');
                cards.forEach(card => {
                    if( card.dataset.isReady === 'true' ) {
                        normalizeTeamGridHeight();
                    } else {
                        card.addEventListener('cardReady', ()=>{ normalizeTeamGridHeight() } );
                    }
                });
            });

            window.addEventListener('resize', handleTeamGridResize );
            setTimeout( ()=> {
                section.querySelectorAll('.team-slide').forEach(slide => {
                    const cards = slide.querySelectorAll('.card');
                    cards.forEach(card => {
                        if (card.collapse) card.collapse();
                    });
                });

                normalizeTeamGridHeight();
                carouselElement.style.transition = 'height 0.5s ease-out';

            } , 200);

            /*
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible' ) {
                    //setTimeout(, 100);

                    setTimeout( ()=> { 
                        handleTeamGridResize();
                        normalizeTeamGridHeight();
                    } , 100 );
                }
            });*/
        
        };

        const handleTeamGridResize = () => {
        
            if( window.matchMedia('(max-width: 768px)').matches ) return;

        /*
            section.querySelectorAll('.team-slide').forEach(slide => {
                const cards = slide.querySelectorAll('.card');
                cards.forEach(card => {
                    if( card.collapse ) card.collapse();
                });
            } );*/

            setTimeout( normalizeTeamGridHeight , 100 );
        };

        const normalizeTeamGridHeight = () => {
            
            section.querySelectorAll('.team-slide').forEach(slide => {

                const cards = slide.querySelectorAll('.card');

                cards.forEach(card => {
                    if (card.dataset.isOpened === 'true') {
                        card.wasOpened = true;
                        card.collapse(true);
                    }
                });


                let normHeight = 0;
                cards.forEach(card => {
                    card.style.height = 'auto';
                    if (card.dataset.isOpened === 'true') {
                        card.wasOpened = true;
                        card.collapse(true);
                    }
                    const cardBottomHeight = card.querySelector('.body .bottom').offsetHeight;
                    const cardHeightAct = card.offsetHeight - cardBottomHeight;

                    if (cardHeightAct > normHeight) normHeight = cardHeightAct;
                });

                cards.forEach(card => {
                    card.dataset.collapseHeight = normHeight;
                    card.style.height = normHeight + 'px';

                    if (card.wasOpened) {
                        card.open(true);
                        card.wasOpened = false;
                    }
                });
            });
        };

        init();

    });

}
